import { createFileRoute } from "@tanstack/react-router";

import { CatalogRoute } from "../screens/catalog-route";

export const Route = createFileRoute("/stores")({
  component: () => (
    <CatalogRoute path="/stores" kind="Location" locationType="Store" />
  ),
});
